module.exports = __webpack_public_path__ + "static/media/mouth.752fdbfc.gif";